export default {"src":"/_next/static/media/sega.be2107c3.svg","height":43,"width":129};